// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ListItemActions-base__EzKTT{display:flex;flex-direction:row;gap:var(--size-2);align-items:center;min-height:var(--size-10);white-space:nowrap}.ListItemActions-chevronWrapper__eNWVy{display:flex;align-items:center;justify-content:center;width:var(--size-8);height:var(--size-8)}.ListItemActions-chevron__xmU6o{color:var(--gray-a9)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"base": "ListItemActions-base__EzKTT",
	"chevronWrapper": "ListItemActions-chevronWrapper__eNWVy",
	"chevron": "ListItemActions-chevron__xmU6o"
};
export default ___CSS_LOADER_EXPORT___;
